import {ISeriesSummaryColumnProduct} from "../../../interfaces";

export const getSeriesSummaryColumnProductLabel = (
  props: ISeriesSummaryColumnProduct
) => {
  return `${props?.title} ${props?.bedroomCount} bed, ${props?.bathroomCount} bath, ${props?.squareFootage} sq.ft.`;
};
